module.exports = __webpack_public_path__ + "img/task_detailBg.1552fee6.png";